import React, { memo, useMemo, Suspense } from 'react';
import { useEngineInstance } from '@surveycake/react-logic-engine';
import { useSurveyConfig } from 'app/core/survey-config';
import Pagination from './Pagination';
import { useStyles } from './styles';
import SurveyProgress from './SurveyProgress';
import SaveTempAnswer from './SaveTempAnswer';
import Divider from './Divider';
import showMultilingualFeature from 'showMultilingualFeature';
import { tempAnswerEnable } from 'config/system';

// Dynamic Import MultilingualSelect
// If user is not using this feature, relative codebase won't be loaded
const LazyMultilingualSelect = React.lazy(() => import('./MultilingualSelect'));

function Footer() {
  const { meta, data } = useSurveyConfig();
  const { temporary_answer_enable } = data;
  const engine = useEngineInstance();

  const { multiplePages } = useMemo(
    () => engine.getSurveyData(),
    [engine]
  );

  const language_list_enable =
    meta && meta.language && meta.language.language_list_enable;
  const language_others =
    meta && meta.language && meta.language.language_others;

  const showMultilingualSelect =
    showMultilingualFeature &&
    language_list_enable &&
    language_others &&
    language_others.length > 0;

  const fatFooter = multiplePages || showMultilingualSelect;
  const styles = useStyles([fatFooter]);

  return (
    <div className={styles.footer}>
      <div className={styles.inner}>
        <SurveyProgress />
        <div className={styles.footerRight}>
          { (tempAnswerEnable && temporary_answer_enable === 1) &&
            <SaveTempAnswer />
          }
          {showMultilingualSelect && (
            <Suspense fallback={''}>
              <LazyMultilingualSelect />
            </Suspense>
          )}
          {multiplePages && showMultilingualSelect && <Divider />}
          {multiplePages && <Pagination />}
        </div>
      </div>
    </div>
  );
}

export default memo(Footer);
